import { api } from '../../shared/lib';

const logout = () => {
  return api.auth.logout().then(() => {
    localStorage.clear();
  });
};

export const authBottomSheetApi = { logout };
